import { render, staticRenderFns } from "./popup-copy-success.vue?vue&type=template&id=e9315700&scoped=true"
import script from "./popup-copy-success.vue?vue&type=script&lang=js"
export * from "./popup-copy-success.vue?vue&type=script&lang=js"
import style0 from "./popup-copy-success.vue?vue&type=style&index=0&id=e9315700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9315700",
  null
  
)

export default component.exports